import { render, staticRenderFns } from "./PaymentKurir.vue?vue&type=template&id=6b0b17cc"
import script from "./PaymentKurir.vue?vue&type=script&lang=js"
export * from "./PaymentKurir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports